import React, { useCallback, useState, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";

import FormTextInput from "Components/FormInput";

import { makeCreateAccountRequest } from "API/Auth";
import { isValidEmail as emailValidator } from "../../../../../Util/validation";
import "./CreateAccountPanel.css";
import { authSuccess } from "Store/features/authSlice";

const LOGIN_FORM_LABELS = {
  EMAIL: "Email",
  PASSWORD: "Password",
  VERIFY_PASSWORD: "Verify Password",
};

const CreateAccountPanel = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");

  const dispatch = useDispatch();

  const isValidEmail = useMemo(() => emailValidator(email), [email]);
  useEffect(() => {
    console.log({ isValidEmail });
  }, [isValidEmail]);

  const handleClickCreateAccount = useCallback(async () => {
    const token = await makeCreateAccountRequest(dispatch, email, password);
    // console.log({token})
    dispatch(authSuccess(token.apiToken));
  }, [email, password]);

  const handleEmailChange = useCallback((e) => setEmail(e.target.value), []);

  const handlePasswordChange = useCallback(
    (e) => setPassword(e.target.value),
    []
  );

  const handleVerifyPasswordChange = useCallback(
    (e) => setVerifyPassword(e.target.value),
    []
  );
  return (
    <div className="create-account-panel-container">
      {/* <div className="create-account-panel-title-container">Create Account</div> */}
      <div className="create-account-panel-description-container">
        Lets get you an account. <br/>
      </div>
      <div className="create-account-panel-form-container">
        <FormTextInput
          inputLabel={LOGIN_FORM_LABELS.EMAIL}
          onChange={handleEmailChange}
          value={email}
        />
        <FormTextInput
          inputLabel={LOGIN_FORM_LABELS.PASSWORD}
          onChange={handlePasswordChange}
          value={password}
          inputType="password"
        />
        <FormTextInput
          inputLabel={LOGIN_FORM_LABELS.VERIFY_PASSWORD}
          onChange={handleVerifyPasswordChange}
          value={verifyPassword}
          inputType="password"
        />
        <div
          className="login-button"
          onClick={handleClickCreateAccount}
        >
          Create Account
        </div>
      </div>
    </div>
  );
};

export default CreateAccountPanel;
